import { StringParam, withDefault } from 'use-query-params';
import { SchemaFilterType, SortDir } from '@ui/src';

export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'orderId',
    label: 'Order ID',
    sortable: false,
  },
  {
    name: 'orderDate',
    label: 'Order date',
    sortable: false,
  },
  {
    name: 'senderId',
    label: 'Sender ID',
    sortable: false,
  },
  {
    name: 'senderName',
    label: 'Sender Name',
    sortable: false,
  },
  {
    name: 'senderAddress',
    label: 'Sender Address',
    sortable: false,
  },
  {
    name: 'senderDob',
    label: 'Sender DOB',
    sortable: false,
  },
  {
    name: 'localCountryId',
    label: 'Local Country',
    sortable: false,
  },
  {
    name: 'localCurrencyId',
    label: 'Local Currency',
    sortable: false,
  },
  {
    name: 'localAmount',
    label: 'Local Amount',
    sortable: false,
  },
  {
    name: 'destCountryId',
    label: 'Destination Country',
    sortable: false,
  },
  {
    name: 'destCurrencyId',
    label: 'Destenation Currency',
    sortable: false,
  },
  {
    name: 'destAmount',
    label: 'Destenation Amount',
    sortable: false,
  },
  {
    name: 'beneficiaryName',
    label: 'Beneficiary Name',
    sortable: false,
  },
  {
    name: 'beneficiaryCity',
    label: 'Payout Location',
    sortable: false,
  },
];

export const columnsLabels = {};

export const defaultSorter = {
  sortProp: columnsItems[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};
